export enum UploadStatus {
    WAITING = 'Waiting',
    PREPARING = 'Preparing',
    UPLOADING = 'Uploading',
    CHECKING_COMPLETION = 'CheckingCompletion',
    FINISHED = 'Finished',
    FAILED = 'Failed',
    REJECTED = 'Rejected',
    ABORTED = 'Aborted',
    CANCELLED = 'Cancelled',
    PAUSED = 'Paused',
    NETWORK_ERROR = 'NetworkError',
    INDEX_TIMEOUT = 'IndexTimeout'
}

export const FinalizedUploadStatuses: UploadStatus[] = [
    UploadStatus.CANCELLED,
    UploadStatus.FAILED,
    UploadStatus.REJECTED,
    UploadStatus.FINISHED,
    UploadStatus.ABORTED,
    UploadStatus.PAUSED,
    UploadStatus.NETWORK_ERROR,
    UploadStatus.INDEX_TIMEOUT
];

export const InProgressUploadStatuses: UploadStatus[] = [
    UploadStatus.WAITING,
    UploadStatus.PREPARING,
    UploadStatus.UPLOADING
];

export const FailedUploadStatuses: UploadStatus[] = [
    UploadStatus.FAILED,
    UploadStatus.REJECTED,
    UploadStatus.NETWORK_ERROR
];
